import { RootState } from 'typesafe-actions';

export const getDisableProductComparisons = ({ disableComparisons }: RootState) => disableComparisons;
